const Edit = (props: React.SVGAttributes<SVGSVGElement>) => (
    <svg
        width='13'
        height='12'
        viewBox='0 0 13 12'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M12.0945 2.47157L10.0321 0.40913C9.76289 0.156289 9.41016 0.0112132 9.04099 0.00149801C8.67181 -0.00821714 8.31194 0.118107 8.02984 0.35644L1.25539 7.13089C1.01209 7.37625 0.860595 7.69784 0.826343 8.04167L0.502675 11.1805C0.492535 11.2908 0.506841 11.4019 0.544572 11.506C0.582304 11.6101 0.642532 11.7045 0.720963 11.7827C0.791297 11.8524 0.87471 11.9076 0.966419 11.9451C1.05813 11.9825 1.15633 12.0015 1.25539 12.001H1.32314L4.46196 11.7149C4.8058 11.6807 5.12739 11.5292 5.37275 11.2859L12.1472 4.51144C12.4101 4.23366 12.5522 3.86298 12.5424 3.48062C12.5325 3.09826 12.3714 2.73541 12.0945 2.47157ZM4.32648 10.2095L2.06833 10.4203L2.27156 8.16211L6.52441 3.96195L8.55674 5.99429L4.32648 10.2095ZM9.53527 4.98565L7.51799 2.96837L8.98579 1.46293L11.0407 3.51785L9.53527 4.98565Z'
            fill='white'
        />
    </svg>
);

export default Edit;
